import React from "react";
import { Link } from "react-router-dom";
import styles from "./Players.module.css";

export const Players = ({ type = "enemies", region, mids, summary }) => {
  let teamMates = {};
  mids.forEach((mid) => {
    const key = mid[0];
    if (summary[key] && summary[key].duration > 360) {
      summary[key][type].forEach((tm) => {
        if (!teamMates[tm]) teamMates[tm] = [0, 0];
        teamMates[tm][0]++;
        if (summary[key].win) teamMates[tm][1]++;
      });
    }
  });
  let commonTeamMates = [];
  Object.keys(teamMates).forEach((tm) => {
    if (teamMates[tm][0] > 1)
      commonTeamMates.push([
        tm,
        teamMates[tm][0],
        teamMates[tm][1],
        Math.round((teamMates[tm][1] / teamMates[tm][0]) * 100),
      ]);
  });
  commonTeamMates.sort((a, b) => {
    a = a[1];
    b = b[1];
    return a > b ? -1 : a < b ? 1 : 0;
  });
  if (!commonTeamMates.length) return "";
  return (
    <div className={styles.players}>
      <div>
        <div>{type === "teamMates" ? "Teammate" : "Enemy"}</div>
        <div>Games</div>
        <div>Wins</div>
        <div>%</div>
      </div>
      {commonTeamMates.map((t, i) => (
        <div key={i}>
          <div>
            <Link
              to={{
                pathname: `/${t[0]
                  .replace(/\s+/g, "")
                  .replace(/#/g, "-")
                  .toLowerCase()}`,
              }}
            >
              {t[0]}
            </Link>
          </div>
          <div>{t[1]}</div>
          <div>{t[2]}</div>
          <div className={styles[t[3] >= 50 ? "green" : "red"]}>{t[3]}%</div>
        </div>
      ))}
    </div>
  );
};
export default Players;
